<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" style="overflow-y: scroll" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div style="margin: 15px;">
          <div v-html="resultHtml"></div>

          <!-- <vs-button class="mb-4 md:mb-0 mr-4 mt-5" style="width: 50%;" @click="showAgreement()">Sözleşmeyi Görüntüle</vs-button>
          <vs-button class="mb-4 md:mb-0 mr-4 mt-5" style="width: 50%;" @click="showAgreementWithInput()">Sözleşmeyi Görüntüle Input</vs-button>
          <vs-input size="small" v-model="orderKey" /> -->
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { router } from "@/router";
import { authenticationService } from "../../_services/authentication.service";
import { repository } from "../../_services/repository";
import { anonymousService } from "../../_services/anonymous.service";

export default {
  data() {
    return {
      ErrorShow: false,
      checkbox_remember_me: false,
      mail: "",
      password: "",
      resultHtml: "",
      orderKey: "",
    };
  },
  created() {
    this.getCreatedHtmlByParams();
  },
  methods: {
    getCreatedHtmlByParams() {
      let keyParam = this.$route.params.key;
      anonymousService.generateSaleOrderAgreement(keyParam).then((list) => {
        this.resultHtml = list.entity;
      });
    },

    showAgreement() {
      let keyParam = this.$route.params.key;

      anonymousService.generateSaleOrderAgreement2(keyParam).then((list) => {
        this.resultHtml = list.entity;
      });
    },

    showAgreementWithInput() {
      let keyParam = this.orderKey;

      authenticationService.login2(keyParam).then((list) => {
        this.resultHtml = list.entity;
      });
    },

    onSubmit() {
      this.submitted = true;
      authenticationService
        .login(this.mail, this.password)
        .then(
          // eslint-disable-next-line
          (user) => router.push(this.returnUrl),
          (error) => {
            this.error = error;
            this.ErrorShow = true;
          }
        )
        .catch((e) => {
          console.warn("login error", e);
          this.ErrorShow = true;
        });
    },
  },
};
</script>

